<template>
  <div class="order-card">
    <div class="order-line-container">
      <OrderSummaryLine
        class="order-line"
        v-for="(order, index) in orders"
        :key="index"
        :order="order"
      />
    </div>
    <div class="alert success">
      <img :src="getIcon('checkmark-circle.svg')" alt="checkmark" />
      <p v-html="$t('AddToCartSection.including_base')"></p>
    </div>
    <AddToCartSection
      :total-price-in-minor-units="totalPriceInMinorUnits"
      :total-discounted-price-in-minor-units="totalDiscountedPriceInMinorUnits"
    />
  </div>
</template>

<script>
import AddToCartSection from './AddToCartSection';
import { mapGetters, mapMutations } from 'vuex';
import OrderSummaryLine from '@/components/order/OrderSummaryLine.vue';
import {
  getCategories,
  calculateTotalPrice,
  calculateTotalDiscountedPrice,
} from '@/services/orderUtils';

export default {
  name: 'OrderSummary',
  components: {
    OrderSummaryLine,
    AddToCartSection,
  },
  computed: {
    ...mapGetters('order', {
      orders: 'getRoomOrders',
    }),
    ...mapGetters({
      calculateTotalPriceWithDiscount:
        'discount/calculateTotalPriceWithDiscount',
    }),
    totalDiscountedPriceInMinorUnits() {
      return calculateTotalDiscountedPrice(
        this.orders,
        this.calculateTotalPriceWithDiscount
      );
    },
    totalPriceInMinorUnits() {
      return this.orders.reduce((total, order) => {
        const categories = getCategories(order.productsWithAmount);
        for (const category of categories) {
          total += calculateTotalPrice(category.products);
        }
        return total;
      }, 0);
    },
  },
  methods: {
    ...mapMutations('step', ['setStep']),
  },
};
</script>
